export interface SalesInvoicePaymentDueDate {
  paymentTermId: string;
  paymentDueDate: Date;
  invoiceDate: Date;
}
